import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { SharedService } from '../shared/shared.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Loader {
  isLoading: boolean = false;
  public isLoadingSubject = new BehaviorSubject(false);

  constructor(
    private loadingCtrl: LoadingController,
    private sharedService: SharedService
  ) {}

  async present() {
    this.isLoading = true;
    return await this.loadingCtrl
      .create(this.sharedService.loading_option)
      .then((a) => {
        a.present().then(() => {
          if (!this.isLoading) {
            a.dismiss();
          }
        });
      });
  }

  async dismiss() {
    this.isLoading = false;
    return await this.loadingCtrl.dismiss();
  }
}
